import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { amazonService } from './amazon.services';
import { dispatchPlacesQueryKeys } from '../dispatch-places/dispatch-places.queries';
import type { ProcessPointsRequest } from './amazon.types';

export const amazonQueryKeys = {
  all: ['amazon'] as const,
  counter: () => [...amazonQueryKeys.all, 'counter'] as const,
  logs: (dpId: string) => [...amazonQueryKeys.all, 'logs', dpId] as const,
  feed: (feedId: string) => [...amazonQueryKeys.all, 'feed', feedId] as const,
};

export const useGetAmazonCounter = () => {
  return useQuery({
    queryKey: amazonQueryKeys.counter(),
    queryFn: amazonService.getCounter,
  });
};

export const useGetAmazonLogs = (dispatchPlaceId: string) => {
  return useQuery({
    queryKey: amazonQueryKeys.logs(dispatchPlaceId),
    queryFn: () => amazonService.getLogsByPoint(dispatchPlaceId),
    enabled: !!dispatchPlaceId,
  });
};

export const useGetAmazonFeedDetail = (feedId: string | null | undefined) => {
  return useQuery({
    queryKey: amazonQueryKeys.feed(feedId || ''),
    queryFn: () => amazonService.getFeedDetail(feedId!),
    enabled: !!feedId,
  });
};

export const useProcessPoints = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ProcessPointsRequest) => amazonService.processPoints(body),
    onSuccess: () => {
      // Invalidate everything relevant
      queryClient.invalidateQueries({ queryKey: amazonQueryKeys.counter() });
      queryClient.invalidateQueries({ queryKey: dispatchPlacesQueryKeys.all });
      // We don't know which logs to invalidate exactly without parsing body,
      // but usually the list refresh covers it.
    },
  });
};
